<template>
  <div id="IndexPage" :style="{ background: tenantConfig.homeBgColor }">
    <div class="banner">
      <a-carousel :autoplay="false" arrows>
        <template #prevArrow>
          <div class="custom-slick-arrow" style="left: 10px; z-index: 1">
            <i class="iconfont">&#xe622;</i>
          </div>
        </template>
        <template #nextArrow>
          <div class="custom-slick-arrow" style="right: 10px">
            <i class="iconfont">&#xe624;</i>
          </div>
        </template>
        <div v-for="(banner, index) in bannerList" :key="index" alt="">
          <div v-if="banner.endsWith('mp4')" class="video-box">
            <div class="video-mask" style=""></div>
            <video class="video" autoplay="" loop="" muted="" :src="banner">
              <source :src="banner" type="video/mp4" />
            </video>
            <div class="typed">
              <vue-typed-js :strings="bannerLinksList" loop smartBackspace>
                <span class="typing"></span>
              </vue-typed-js>
            </div>
          </div>
          <img class="img" v-else :src="banner" />
        </div>
      </a-carousel>
    </div>
    <div class="index-content">
      <div class="index-container gray">
        <div class="second-title"><strong>为什么</strong>孩子要学编程</div>
        <div class="second-desc">
          用编程培养未来世界的创造者，让孩子理解科技、锻炼思维、提升能力
        </div>
        <div class="second-body">
          <a-row :gutter="[24, 24]" class="ai-list">
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/ai01.png" />
                <div class="title">理解AI，掌握未来</div>
                <div class="text">
                  编程是与人工智能沟通的语言，学习编程，让孩子成为未来世界的创造者，为未来更好的适应社会提供保障
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/ai02.png" />
                <div class="title">培养多项核心能力</div>
                <div class="text">
                  以编程为载体，融合多学科知识，促进逻辑思维、创造力、专注力、学习力等多方位能力培养
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/ai03.png" />
                <div class="title">提升学习竞争力</div>
                <div class="text">
                  全国多地已将编程纳入中小学必修课，更有多项青少年科创赛事待孩子崭露头角、增强自信
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 编辑器 -->
      <div class="index-container">
        <div class="second-title"><strong>不同年龄</strong>的孩子怎么选</div>
        <div class="second-desc">
          融合少儿认知规律、语言本身实用性和经典性、竞赛出口等多层考虑，创建适合小中高年龄段孩子的课程体系
        </div>
        <div class="second-body">
          <a-row :gutter="[24, 24]" class="editor-list">
            <a-col :span="6">
              <a-card
                :bordered="false"
                :style="{
                  backgroundImage:
                    'url(' + require('../assets/index2/choice01.png') + ')',
                }"
              >
                <div class="title">ScratchJR</div>
                <div class="text">像搭积木一样学编程</div>
                <div class="age">
                  <p>适合</p>
                  <p>4-9岁</p>
                </div>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-card
                :bordered="false"
                :style="{
                  backgroundImage:
                    'url(' + require('../assets/index2/choice02.png') + ')',
                }"
              >
                <div class="title">Scratch</div>
                <div class="text">像搭积木一样学编程</div>
                <div class="age">
                  <p>适合</p>
                  <p>6-11岁</p>
                </div>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-card
                :bordered="false"
                :style="{
                  backgroundImage:
                    'url(' + require('../assets/index2/choice03.png') + ')',
                }"
              >
                <div class="title">Python</div>
                <div class="text">人工智能时代的智慧语言</div>
                <div class="age">
                  <p>适合</p>
                  <p>8-13岁</p>
                </div>
              </a-card>
            </a-col>
            <a-col :span="6">
              <a-card
                :bordered="false"
                :style="{
                  backgroundImage:
                    'url(' + require('../assets/index2/choice04.png') + ')',
                }"
              >
                <div class="title">C++</div>
                <div class="text">高阶信息学竞赛常用语言</div>
                <div class="age">
                  <p>适合</p>
                  <p>11-16岁</p>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 选择 -->
      <div class="index-container skyblue">
        <div class="second-title">
          <strong>为什么</strong>选择{{ tenantConfig.brandName }}
        </div>
        <div class="second-desc">
          课程好、老师好、授课形式多、学员作品棒、流程智能化、口碑好
        </div>
      </div>
      <!-- 课程 -->
      <div class="index-container gray sub">
        <div class="second-title">
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABFxJREFUWEftWUFrXlUQPTPzkrSGVhGroIsiIu50I4roSrFtVuJCF0KrNC79CW5duVBbl4JCF6IIgpK2FMQuLPofrD9ABRepNW2S742cmbnfeyZV3HzZ9AXCfbn3vrn3nTNnZu6NYPo5MATevuRPiuMNAE/w1wT3CPCrAD8p8PXHa3J172bkwHZ3Fy+0/p0f77fxrjpehkAVMDhMkM9sJft/XBK888Epud7gmghasOO8dcUflx1cEMWD4jCMSIlnEsN+gXJcBZsCvH5uTX7g1iaCFkjQ+oYfnwm+APCAOnSunkYGlQSoAQoqif3Zt6mGF86dkJ8nghZI0JmLfl6AEwSdShEvAlI1SQrHhhDH0JdhT3Hto1Py4kTQggg6e9mf2u3xeSOHwBcZEc4Y1kgaFSRAJ4BEbiI5nCvxfFLgLrgKwzEofodiG3b/DPbHbegRh91Ygqz2MAfMl6ArDvMZ1KtdXoZ5D+34dw91g3aca1CrPgPMNN5RMxhbbjDa8i628bcOY3PPqzl9Dwvb9MbyQtruAesk7fMDjeM9TCy9NvqafankXPNj/ZaoK9S0nBD9AoncQPCGBJ+JvkJSKCBtSLWZ+FkItDlNQQl85p3MQTZSE+1EX7SOTwVwwZf5EbgJxcMDQUcPQ/tNmK8G4HKoh/21C10BbJkAd9DbPXSJzwZtRAWIfcRWc62W5HBTS+kpjSAS1xOAGSzI+ReCCH7YpXeR/KyEVDSBQJ8eWWAPYFVfOEeR29YnCAFyeXSAmh6cZNDD09MHe00JA9CZN3KdRtQ+grhX4zskvL5//s5A5Hj/tPXLoKAtGP6E4l4obkHv62GzkYIOA3aTCtpKJaErYqgah4WCOijVhQKwKaizQRWcW94nS4IuVDMCkQT5LqyzBJz2RCtWp/QDhABcqy2F0cmCwBprXt0UFGqq9/lM4PdUVZkPqtKqxL1fQaXesF8Jv9aKd0cqoOOE0xXx2Q75qBsXCeUQ+Y2OTgRbqaDvYRHejkEf2obtVIijgjZ3oKtb6HwlgNOVQ0OIWx4riEoiMQSdpN1BQVBoKI/gVKijguix83BXYAfQLbkO4SlVUGNzRdDT9yiIFWqFqEzGRa7yw3XkxeX1DDMBTKolk3WSOYSqUtNoLO3+DwXdqYpjKI4c1BSUbThJ5aZbU5GwoCLhzGX/Fj0emzsZc2LlllYktHPQP4qEystIoq5PBC2KoIv+HoBX61wT+WdPiI1QFyovFUZBMqroqkhY0A7vcrOnN/xZAT4LEoa81yq3diZinsnnNicLCOZKVqwnJwUt0JHevOQX4HhmfBaal+tDmZ1HjjoeRGUqUXFe+3BNXpoIWiBBp7/xR63DVyI4Oq/ixuegoTSPg+roDLUp01XPApkZmT674U+74hM4jozUw9AmdaPdSvt2q31Dgdemy9KD4SdW4aVpD7yvkuGuSui8wRju5Zirpn83HCAv+5Zav+LPywyvKPAcgEfq/u23//qH3d+BYW6gbfXPHQAAAABJRU5ErkJggg=="
          />
          {{ tenantConfig.brandName }}的课程好
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABKFJREFUWEftWc+LXEUQ/urNjM6KG3IxN2/rxb8gag5CILhZLyIigoI5eNNs4sGLFw/+CTmJG+IGPHgQcsmsEUXwBypeFPwRFNGLlwRxdUIyM6+qpKqre3qye8w7zSwsr1+/7nrd9dX3VfUbwiF/r470SQGeUeC4EI6p4LYC1wFcV8L7727SD4fNW/Xdew9QbfL8nm7MFBcEeEwVIoAowAoI4PfWZiV83NyHt3dO0p/3fkkri7UHCkBnR3pCgQ8EWFeFBhAGDIs6KGKg5X4R3MAAL146Rb+uXNqdBxygs9f0ERV8AcW6scWZYmAQxMBx9lBiDww8BQs5q272FM/vbK2Y1BVEDtD2SD9RxQlzujvfJC3AcVCS1BW5UwJzAKfAtd3T9FpXC1x2u/T6SE+2wEcGDBJLnEEFIIVWuccZ5OAYmJGT+g1euPgUfb/szuxi/3T+qr4jhDMOzGG5xvoSoywXebGQJc4Bsr4mPasKCr93RiZZFGnAKm7LAbfcZky0fBd5zmXU+1OQ+FwbS4nNyRZB2OwkiV3IjVmabTzbPE1XW0du2zNbR16bXc12k8axCMTfl3KvX92eRLsJ2xJXuycwMaS1sQyhBtJaXwOZTsHUc5s8AfgBgd6xZwDfmkDW+5AegZv7IX/fBONhMG5A8CMEb4Fpe09/hmIjqra7N5ycEjnIHZ0dXjEo5C/lq9Sf2gFcmWcbnQOeAmJeJbq0RsXoznLwEzAlBxYQAmgHIoCSAC4cmvNkAbUGrgLIAsdBmUkCw9sBcAkQTs+mFkQx3t6dwXFQ7gaohUwBHvbSPANqcgdMfYj/E3g8BmMAwS2zCsYQgkfB+AmM5yC0PdL/VLHmDJnnmRT18zxUyuwqasv4kMPCoGCIz7FoN6AWIj8DXRchBoSxTD2/5Si2gGhtbmaAAxYMCfAOsigFlTPTGRT2MqvsPQamWMFjjotgy4ypWettY0uwytrUB5vDB5zY0zYQZ06wKLNngUFDMI0hkzUwzSAWVDSAjBvw0dsQZ1APjP2kDHgIgs8gdG6k/yqwVktILVfZ2XUVZyygStbKGSmcFxLVmpwViZufoRKQxo4AyIuSJGeJQUkS28zqLHGV3CSJq8r+EggZmJAx32wli2arDaa4hJqNHlhmEOknMJxBxphmLnHCzhaXLw42FQY1SSJnBpLJWRsSFww6IHFDtDSBOEBj8NEB5B8LYgNnCNl4EPLbGK0z6NxIfxFgA1E658Qfm3IaWkRbpEX+WcxByQG/727S010kyWW36UUCE844CyKHZJ2PyLaobuNMVBJ1jr6QnA93T9Oby+7MLvbvZTYDe071YInngJCwOKgWnc8luOWKKAYMtJcvb9E3XSxw2W3mg+qnqngiH1RzZWWAOYtSwVC+JNTnIBC+fW+TXlp2R3a1//pTz+cqOOKJuyqlvRJKCX1+Dpq390F49tIm/dHVApfd7oGPpQocqb7FFVBKNRdVkRL2ifHKxS36btmd2OX+D/zcMFVcUMXjXvYussnPRn4oJXxNgjdWH0m7hCbZXgAovy7/YCfAcQWO+XlG8ZcSvtIeruycoi+7X9rqDeaB/wEbDb3MbAVAFAAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="second-desc">
          专家把关，先进教育理念支撑，课程更专业，孩子更喜欢！
        </div>
        <div class="second-body">
          <a-row
            tye="flex"
            :gutter="[24, 24]"
            class="course-list"
            justify="space-around"
            align="middle"
          >
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/course01.png" />
                <div class="title">
                  <img
                    style="width: 22px; margin-right: 16px"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAt1JREFUWEfVmc1LVFEUwH9n8i0CxUVQIC0CxVoUCP0DbSuojD4ggghqU7pIg2CcnBmdBoKMCGtTEEEFfZAoVMv6B4IgFyUJLWTAoEUptJiaE9c7k5Pje+++IfR2N2/gnY/fO+eecz9GaHZktBPlIMpuhA6UjqWnGUoJoVR9vkWYpCCzzbiSREo53cxP+qjQC+xMpAvTpJighXFy8sVV1w0wq62UGUS4iNLqanxVOWER5RoBY+RlMc5WPGBGD1PhNrAlzljC9/OkOEdBnkfphQOqCkMMA1kg/kMS0lXFFchzhRFEzO+Gsbrj67qRr9xHOdqc34RawlM2cYoB+bFSsxHQRC7D4zWDqxEZyALHV0ayETCtJqW5hDH4V+I5ipKvN/Y3oC2IZwnm3BwwCbwgwPS5UtV4B2U6gf3AQWCr4xcoKY7UF84yoG0lnxyr1YBk6eEex+RXpPMnuoF3nF4qBqqNPJp2noCuWgtaBnRP7RTtnOSSLDhGxYpd1Ta+8QA44KD3J9UW0KwQZWZjm7BwkxYukJeKg5NGkaymKHMD6I/UN808oNOsOBZwSEdRMjFOpwjobRquZtxCTsRGMsUoBRm2gGl9H7O2lmhnR+K0hn2xTfeHmDk5TVF2CWZXUlkqjqhxlqLcbSqtYUppPQPcibSZoksY0gGUsQjBOXrYFlutSeltdX+ObEHCoJDWh8CJCPu3KEpfUv9O8mkdB85HyD4yEXyNsidCaB9FeeXkMKlQWvcCL0PVhDcmgh+B7lChgO3kZSapbyf5rHZTxvgPGzMmgguR/S+gzWVj6QS0UsiuXuENX1g0EfwOtEVEcP0AYeG/SLH3ReJ9m/G8UXu/1Hm/WTCAGR2hwuWYXraO2y3vN6w2za6nuXXY8htA7w9Ndi56fOysVYh7qpvaH8QoxRzcjbb3Vx8G0uvLo1oOvL5+q58o3l5g1kN6fQVcD2pXnH6UQ35doq/WG9bob4jf3UNodgEgiG8AAAAASUVORK5CYII="
                  />
                  先进理念
                </div>
                <div class="text">
                  以内在成就感驱动的建构主义教育，以孩子的学习认知曲线为依据，培养批判性思维，激发创新力和探究式学习能力
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/course02.png" />
                <div class="title">
                  <img
                    style="width: 22px; margin-right: 16px"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAt1JREFUWEfVmc1LVFEUwH9n8i0CxUVQIC0CxVoUCP0DbSuojD4ggghqU7pIg2CcnBmdBoKMCGtTEEEFfZAoVMv6B4IgFyUJLWTAoEUptJiaE9c7k5Pje+++IfR2N2/gnY/fO+eecz9GaHZktBPlIMpuhA6UjqWnGUoJoVR9vkWYpCCzzbiSREo53cxP+qjQC+xMpAvTpJighXFy8sVV1w0wq62UGUS4iNLqanxVOWER5RoBY+RlMc5WPGBGD1PhNrAlzljC9/OkOEdBnkfphQOqCkMMA1kg/kMS0lXFFchzhRFEzO+Gsbrj67qRr9xHOdqc34RawlM2cYoB+bFSsxHQRC7D4zWDqxEZyALHV0ayETCtJqW5hDH4V+I5ipKvN/Y3oC2IZwnm3BwwCbwgwPS5UtV4B2U6gf3AQWCr4xcoKY7UF84yoG0lnxyr1YBk6eEex+RXpPMnuoF3nF4qBqqNPJp2noCuWgtaBnRP7RTtnOSSLDhGxYpd1Ta+8QA44KD3J9UW0KwQZWZjm7BwkxYukJeKg5NGkaymKHMD6I/UN808oNOsOBZwSEdRMjFOpwjobRquZtxCTsRGMsUoBRm2gGl9H7O2lmhnR+K0hn2xTfeHmDk5TVF2CWZXUlkqjqhxlqLcbSqtYUppPQPcibSZoksY0gGUsQjBOXrYFlutSeltdX+ObEHCoJDWh8CJCPu3KEpfUv9O8mkdB85HyD4yEXyNsidCaB9FeeXkMKlQWvcCL0PVhDcmgh+B7lChgO3kZSapbyf5rHZTxvgPGzMmgguR/S+gzWVj6QS0UsiuXuENX1g0EfwOtEVEcP0AYeG/SLH3ReJ9m/G8UXu/1Hm/WTCAGR2hwuWYXraO2y3vN6w2za6nuXXY8htA7w9Ndi56fOysVYh7qpvaH8QoxRzcjbb3Vx8G0uvLo1oOvL5+q58o3l5g1kN6fQVcD2pXnH6UQ35doq/WG9bob4jf3UNodgEgiG8AAAAASUVORK5CYII="
                  />科学体系
                </div>
                <div class="text">
                  从孩子认知学习的规律出发，以儿童对编程学习的认知曲线为基础，融合少儿认知规律、语言本身实用性和经典性、竞赛等多层考虑，创建覆盖小中高全年龄段的课程体系
                </div>
              </a-card>
            </a-col>
            <a-col :span="8">
              <a-card :bordered="false">
                <img src="../assets/index2/course03.png" />
                <div class="title">
                  <img
                    style="width: 22px; margin-right: 16px"
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAt1JREFUWEfVmc1LVFEUwH9n8i0CxUVQIC0CxVoUCP0DbSuojD4ggghqU7pIg2CcnBmdBoKMCGtTEEEFfZAoVMv6B4IgFyUJLWTAoEUptJiaE9c7k5Pje+++IfR2N2/gnY/fO+eecz9GaHZktBPlIMpuhA6UjqWnGUoJoVR9vkWYpCCzzbiSREo53cxP+qjQC+xMpAvTpJighXFy8sVV1w0wq62UGUS4iNLqanxVOWER5RoBY+RlMc5WPGBGD1PhNrAlzljC9/OkOEdBnkfphQOqCkMMA1kg/kMS0lXFFchzhRFEzO+Gsbrj67qRr9xHOdqc34RawlM2cYoB+bFSsxHQRC7D4zWDqxEZyALHV0ayETCtJqW5hDH4V+I5ipKvN/Y3oC2IZwnm3BwwCbwgwPS5UtV4B2U6gf3AQWCr4xcoKY7UF84yoG0lnxyr1YBk6eEex+RXpPMnuoF3nF4qBqqNPJp2noCuWgtaBnRP7RTtnOSSLDhGxYpd1Ta+8QA44KD3J9UW0KwQZWZjm7BwkxYukJeKg5NGkaymKHMD6I/UN808oNOsOBZwSEdRMjFOpwjobRquZtxCTsRGMsUoBRm2gGl9H7O2lmhnR+K0hn2xTfeHmDk5TVF2CWZXUlkqjqhxlqLcbSqtYUppPQPcibSZoksY0gGUsQjBOXrYFlutSeltdX+ObEHCoJDWh8CJCPu3KEpfUv9O8mkdB85HyD4yEXyNsidCaB9FeeXkMKlQWvcCL0PVhDcmgh+B7lChgO3kZSapbyf5rHZTxvgPGzMmgguR/S+gzWVj6QS0UsiuXuENX1g0EfwOtEVEcP0AYeG/SLH3ReJ9m/G8UXu/1Hm/WTCAGR2hwuWYXraO2y3vN6w2za6nuXXY8htA7w9Ndi56fOysVYh7qpvaH8QoxRzcjbb3Vx8G0uvLo1oOvL5+q58o3l5g1kN6fQVcD2pXnH6UQ35doq/WG9bob4jf3UNodgEgiG8AAAAASUVORK5CYII="
                  />精研课程
                </div>
                <div class="text">
                  基于科学的课程大纲，课堂内容涉及科学、艺术、数理、自然等多领域知识，通过9种课堂形式将理论与实践融合，打造孩子感兴趣、快乐有成长的编程课堂
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 老师 -->
      <div class="index-container sub">
        <div class="second-title">
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABFxJREFUWEftWUFrXlUQPTPzkrSGVhGroIsiIu50I4roSrFtVuJCF0KrNC79CW5duVBbl4JCF6IIgpK2FMQuLPofrD9ABRepNW2S742cmbnfeyZV3HzZ9AXCfbn3vrn3nTNnZu6NYPo5MATevuRPiuMNAE/w1wT3CPCrAD8p8PXHa3J172bkwHZ3Fy+0/p0f77fxrjpehkAVMDhMkM9sJft/XBK888Epud7gmghasOO8dcUflx1cEMWD4jCMSIlnEsN+gXJcBZsCvH5uTX7g1iaCFkjQ+oYfnwm+APCAOnSunkYGlQSoAQoqif3Zt6mGF86dkJ8nghZI0JmLfl6AEwSdShEvAlI1SQrHhhDH0JdhT3Hto1Py4kTQggg6e9mf2u3xeSOHwBcZEc4Y1kgaFSRAJ4BEbiI5nCvxfFLgLrgKwzEofodiG3b/DPbHbegRh91Ygqz2MAfMl6ArDvMZ1KtdXoZ5D+34dw91g3aca1CrPgPMNN5RMxhbbjDa8i628bcOY3PPqzl9Dwvb9MbyQtruAesk7fMDjeM9TCy9NvqafankXPNj/ZaoK9S0nBD9AoncQPCGBJ+JvkJSKCBtSLWZ+FkItDlNQQl85p3MQTZSE+1EX7SOTwVwwZf5EbgJxcMDQUcPQ/tNmK8G4HKoh/21C10BbJkAd9DbPXSJzwZtRAWIfcRWc62W5HBTS+kpjSAS1xOAGSzI+ReCCH7YpXeR/KyEVDSBQJ8eWWAPYFVfOEeR29YnCAFyeXSAmh6cZNDD09MHe00JA9CZN3KdRtQ+grhX4zskvL5//s5A5Hj/tPXLoKAtGP6E4l4obkHv62GzkYIOA3aTCtpKJaErYqgah4WCOijVhQKwKaizQRWcW94nS4IuVDMCkQT5LqyzBJz2RCtWp/QDhABcqy2F0cmCwBprXt0UFGqq9/lM4PdUVZkPqtKqxL1fQaXesF8Jv9aKd0cqoOOE0xXx2Q75qBsXCeUQ+Y2OTgRbqaDvYRHejkEf2obtVIijgjZ3oKtb6HwlgNOVQ0OIWx4riEoiMQSdpN1BQVBoKI/gVKijguix83BXYAfQLbkO4SlVUGNzRdDT9yiIFWqFqEzGRa7yw3XkxeX1DDMBTKolk3WSOYSqUtNoLO3+DwXdqYpjKI4c1BSUbThJ5aZbU5GwoCLhzGX/Fj0emzsZc2LlllYktHPQP4qEystIoq5PBC2KoIv+HoBX61wT+WdPiI1QFyovFUZBMqroqkhY0A7vcrOnN/xZAT4LEoa81yq3diZinsnnNicLCOZKVqwnJwUt0JHevOQX4HhmfBaal+tDmZ1HjjoeRGUqUXFe+3BNXpoIWiBBp7/xR63DVyI4Oq/ixuegoTSPg+roDLUp01XPApkZmT674U+74hM4jozUw9AmdaPdSvt2q31Dgdemy9KD4SdW4aVpD7yvkuGuSui8wRju5Zirpn83HCAv+5Zav+LPywyvKPAcgEfq/u23//qH3d+BYW6gbfXPHQAAAABJRU5ErkJggg=="
          />

          {{ tenantConfig.brandName }}的老师好
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABKFJREFUWEftWc+LXEUQ/urNjM6KG3IxN2/rxb8gag5CILhZLyIigoI5eNNs4sGLFw/+CTmJG+IGPHgQcsmsEUXwBypeFPwRFNGLlwRxdUIyM6+qpKqre3qye8w7zSwsr1+/7nrd9dX3VfUbwiF/r470SQGeUeC4EI6p4LYC1wFcV8L7727SD4fNW/Xdew9QbfL8nm7MFBcEeEwVIoAowAoI4PfWZiV83NyHt3dO0p/3fkkri7UHCkBnR3pCgQ8EWFeFBhAGDIs6KGKg5X4R3MAAL146Rb+uXNqdBxygs9f0ERV8AcW6scWZYmAQxMBx9lBiDww8BQs5q272FM/vbK2Y1BVEDtD2SD9RxQlzujvfJC3AcVCS1BW5UwJzAKfAtd3T9FpXC1x2u/T6SE+2wEcGDBJLnEEFIIVWuccZ5OAYmJGT+g1euPgUfb/szuxi/3T+qr4jhDMOzGG5xvoSoywXebGQJc4Bsr4mPasKCr93RiZZFGnAKm7LAbfcZky0fBd5zmXU+1OQ+FwbS4nNyRZB2OwkiV3IjVmabTzbPE1XW0du2zNbR16bXc12k8axCMTfl3KvX92eRLsJ2xJXuycwMaS1sQyhBtJaXwOZTsHUc5s8AfgBgd6xZwDfmkDW+5AegZv7IX/fBONhMG5A8CMEb4Fpe09/hmIjqra7N5ycEjnIHZ0dXjEo5C/lq9Sf2gFcmWcbnQOeAmJeJbq0RsXoznLwEzAlBxYQAmgHIoCSAC4cmvNkAbUGrgLIAsdBmUkCw9sBcAkQTs+mFkQx3t6dwXFQ7gaohUwBHvbSPANqcgdMfYj/E3g8BmMAwS2zCsYQgkfB+AmM5yC0PdL/VLHmDJnnmRT18zxUyuwqasv4kMPCoGCIz7FoN6AWIj8DXRchBoSxTD2/5Si2gGhtbmaAAxYMCfAOsigFlTPTGRT2MqvsPQamWMFjjotgy4ypWettY0uwytrUB5vDB5zY0zYQZ06wKLNngUFDMI0hkzUwzSAWVDSAjBvw0dsQZ1APjP2kDHgIgs8gdG6k/yqwVktILVfZ2XUVZyygStbKGSmcFxLVmpwViZufoRKQxo4AyIuSJGeJQUkS28zqLHGV3CSJq8r+EggZmJAx32wli2arDaa4hJqNHlhmEOknMJxBxphmLnHCzhaXLw42FQY1SSJnBpLJWRsSFww6IHFDtDSBOEBj8NEB5B8LYgNnCNl4EPLbGK0z6NxIfxFgA1E658Qfm3IaWkRbpEX+WcxByQG/727S010kyWW36UUCE844CyKHZJ2PyLaobuNMVBJ1jr6QnA93T9Oby+7MLvbvZTYDe071YInngJCwOKgWnc8luOWKKAYMtJcvb9E3XSxw2W3mg+qnqngiH1RzZWWAOYtSwVC+JNTnIBC+fW+TXlp2R3a1//pTz+cqOOKJuyqlvRJKCX1+Dpq390F49tIm/dHVApfd7oGPpQocqb7FFVBKNRdVkRL2ifHKxS36btmd2OX+D/zcMFVcUMXjXvYussnPRn4oJXxNgjdWH0m7hCbZXgAovy7/YCfAcQWO+XlG8ZcSvtIeruycoi+7X9rqDeaB/wEbDb3MbAVAFAAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="second-body">
          <img src="../assets/index2/content-bg.png" alt="" />
        </div>
      </div>

      <!-- 作品 -->
      <div class="index-container sub skyblue">
        <div class="second-title">
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABFxJREFUWEftWUFrXlUQPTPzkrSGVhGroIsiIu50I4roSrFtVuJCF0KrNC79CW5duVBbl4JCF6IIgpK2FMQuLPofrD9ABRepNW2S742cmbnfeyZV3HzZ9AXCfbn3vrn3nTNnZu6NYPo5MATevuRPiuMNAE/w1wT3CPCrAD8p8PXHa3J172bkwHZ3Fy+0/p0f77fxrjpehkAVMDhMkM9sJft/XBK888Epud7gmghasOO8dcUflx1cEMWD4jCMSIlnEsN+gXJcBZsCvH5uTX7g1iaCFkjQ+oYfnwm+APCAOnSunkYGlQSoAQoqif3Zt6mGF86dkJ8nghZI0JmLfl6AEwSdShEvAlI1SQrHhhDH0JdhT3Hto1Py4kTQggg6e9mf2u3xeSOHwBcZEc4Y1kgaFSRAJ4BEbiI5nCvxfFLgLrgKwzEofodiG3b/DPbHbegRh91Ygqz2MAfMl6ArDvMZ1KtdXoZ5D+34dw91g3aca1CrPgPMNN5RMxhbbjDa8i628bcOY3PPqzl9Dwvb9MbyQtruAesk7fMDjeM9TCy9NvqafankXPNj/ZaoK9S0nBD9AoncQPCGBJ+JvkJSKCBtSLWZ+FkItDlNQQl85p3MQTZSE+1EX7SOTwVwwZf5EbgJxcMDQUcPQ/tNmK8G4HKoh/21C10BbJkAd9DbPXSJzwZtRAWIfcRWc62W5HBTS+kpjSAS1xOAGSzI+ReCCH7YpXeR/KyEVDSBQJ8eWWAPYFVfOEeR29YnCAFyeXSAmh6cZNDD09MHe00JA9CZN3KdRtQ+grhX4zskvL5//s5A5Hj/tPXLoKAtGP6E4l4obkHv62GzkYIOA3aTCtpKJaErYqgah4WCOijVhQKwKaizQRWcW94nS4IuVDMCkQT5LqyzBJz2RCtWp/QDhABcqy2F0cmCwBprXt0UFGqq9/lM4PdUVZkPqtKqxL1fQaXesF8Jv9aKd0cqoOOE0xXx2Q75qBsXCeUQ+Y2OTgRbqaDvYRHejkEf2obtVIijgjZ3oKtb6HwlgNOVQ0OIWx4riEoiMQSdpN1BQVBoKI/gVKijguix83BXYAfQLbkO4SlVUGNzRdDT9yiIFWqFqEzGRa7yw3XkxeX1DDMBTKolk3WSOYSqUtNoLO3+DwXdqYpjKI4c1BSUbThJ5aZbU5GwoCLhzGX/Fj0emzsZc2LlllYktHPQP4qEystIoq5PBC2KoIv+HoBX61wT+WdPiI1QFyovFUZBMqroqkhY0A7vcrOnN/xZAT4LEoa81yq3diZinsnnNicLCOZKVqwnJwUt0JHevOQX4HhmfBaal+tDmZ1HjjoeRGUqUXFe+3BNXpoIWiBBp7/xR63DVyI4Oq/ixuegoTSPg+roDLUp01XPApkZmT674U+74hM4jozUw9AmdaPdSvt2q31Dgdemy9KD4SdW4aVpD7yvkuGuSui8wRju5Zirpn83HCAv+5Zav+LPywyvKPAcgEfq/u23//qH3d+BYW6gbfXPHQAAAABJRU5ErkJggg=="
          />
          {{ tenantConfig.brandName }}的学员作品棒
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABKFJREFUWEftWc+LXEUQ/urNjM6KG3IxN2/rxb8gag5CILhZLyIigoI5eNNs4sGLFw/+CTmJG+IGPHgQcsmsEUXwBypeFPwRFNGLlwRxdUIyM6+qpKqre3qye8w7zSwsr1+/7nrd9dX3VfUbwiF/r470SQGeUeC4EI6p4LYC1wFcV8L7727SD4fNW/Xdew9QbfL8nm7MFBcEeEwVIoAowAoI4PfWZiV83NyHt3dO0p/3fkkri7UHCkBnR3pCgQ8EWFeFBhAGDIs6KGKg5X4R3MAAL146Rb+uXNqdBxygs9f0ERV8AcW6scWZYmAQxMBx9lBiDww8BQs5q272FM/vbK2Y1BVEDtD2SD9RxQlzujvfJC3AcVCS1BW5UwJzAKfAtd3T9FpXC1x2u/T6SE+2wEcGDBJLnEEFIIVWuccZ5OAYmJGT+g1euPgUfb/szuxi/3T+qr4jhDMOzGG5xvoSoywXebGQJc4Bsr4mPasKCr93RiZZFGnAKm7LAbfcZky0fBd5zmXU+1OQ+FwbS4nNyRZB2OwkiV3IjVmabTzbPE1XW0du2zNbR16bXc12k8axCMTfl3KvX92eRLsJ2xJXuycwMaS1sQyhBtJaXwOZTsHUc5s8AfgBgd6xZwDfmkDW+5AegZv7IX/fBONhMG5A8CMEb4Fpe09/hmIjqra7N5ycEjnIHZ0dXjEo5C/lq9Sf2gFcmWcbnQOeAmJeJbq0RsXoznLwEzAlBxYQAmgHIoCSAC4cmvNkAbUGrgLIAsdBmUkCw9sBcAkQTs+mFkQx3t6dwXFQ7gaohUwBHvbSPANqcgdMfYj/E3g8BmMAwS2zCsYQgkfB+AmM5yC0PdL/VLHmDJnnmRT18zxUyuwqasv4kMPCoGCIz7FoN6AWIj8DXRchBoSxTD2/5Si2gGhtbmaAAxYMCfAOsigFlTPTGRT2MqvsPQamWMFjjotgy4ypWettY0uwytrUB5vDB5zY0zYQZ06wKLNngUFDMI0hkzUwzSAWVDSAjBvw0dsQZ1APjP2kDHgIgs8gdG6k/yqwVktILVfZ2XUVZyygStbKGSmcFxLVmpwViZufoRKQxo4AyIuSJGeJQUkS28zqLHGV3CSJq8r+EggZmJAx32wli2arDaa4hJqNHlhmEOknMJxBxphmLnHCzhaXLw42FQY1SSJnBpLJWRsSFww6IHFDtDSBOEBj8NEB5B8LYgNnCNl4EPLbGK0z6NxIfxFgA1E658Qfm3IaWkRbpEX+WcxByQG/727S010kyWW36UUCE844CyKHZJ2PyLaobuNMVBJ1jr6QnA93T9Oby+7MLvbvZTYDe071YInngJCwOKgWnc8luOWKKAYMtJcvb9E3XSxw2W3mg+qnqngiH1RzZWWAOYtSwVC+JNTnIBC+fW+TXlp2R3a1//pTz+cqOOKJuyqlvRJKCX1+Dpq390F49tIm/dHVApfd7oGPpQocqb7FFVBKNRdVkRL2ifHKxS36btmd2OX+D/zcMFVcUMXjXvYussnPRn4oJXxNgjdWH0m7hCbZXgAovy7/YCfAcQWO+XlG8ZcSvtIeruycoi+7X9rqDeaB/wEbDb3MbAVAFAAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="second-desc">
          <router-link :to="{ path: '/work/list' }"
            >查看更多作品 >></router-link
          >
        </div>
        <div class="second-body">
          <a-row type="flex" :gutter="[24, 24]">
            <a-col
              v-for="(item, index) in workList"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="6"
              :xl="6"
            >
              <a-card class="work-card">
                <div class="work-cover">
                  <a @click="toDetail(item)" target="_blank" class="img-zoom">
                    <img v-if="item.workCover" :src="item.workCover_url" />
                    <img v-else :src="getCodeIcon(item.codeType)" />
                  </a>
                </div>
                <a-row class="work-author">
                  <a-col :span="6">
                    <a-avatar
                      shape="square"
                      class="avatar"
                      :size="40"
                      :src="item.avatar ? item.avatar_url : '/img/avatar.png'"
                      @click="toUserInfo(item)"
                      style="cursor: pointer"
                    />
                  </a-col>
                  <a-col :span="18">
                    <span @click="toUserInfo(item)" style="cursor: pointer">{{
                      item.realname || item.username
                    }}</span>
                  </a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="work-op">
                  <a @click="toDetail(item)">{{ item.workName }}</a>
                  <a-row type="flex" justify="end">
                    <a-col :span="6">
                      <a-icon type="eye" /> {{ item.viewNum }}
                    </a-col>
                    <a-col :span="6">
                      <a-icon type="like" /> {{ item.starNum }}
                    </a-col>
                  </a-row>
                </div>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </div>
      <!-- 教学流程智能化 -->
      <div class="index-container sub">
        <div class="second-title">
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABFxJREFUWEftWUFrXlUQPTPzkrSGVhGroIsiIu50I4roSrFtVuJCF0KrNC79CW5duVBbl4JCF6IIgpK2FMQuLPofrD9ABRepNW2S742cmbnfeyZV3HzZ9AXCfbn3vrn3nTNnZu6NYPo5MATevuRPiuMNAE/w1wT3CPCrAD8p8PXHa3J172bkwHZ3Fy+0/p0f77fxrjpehkAVMDhMkM9sJft/XBK888Epud7gmghasOO8dcUflx1cEMWD4jCMSIlnEsN+gXJcBZsCvH5uTX7g1iaCFkjQ+oYfnwm+APCAOnSunkYGlQSoAQoqif3Zt6mGF86dkJ8nghZI0JmLfl6AEwSdShEvAlI1SQrHhhDH0JdhT3Hto1Py4kTQggg6e9mf2u3xeSOHwBcZEc4Y1kgaFSRAJ4BEbiI5nCvxfFLgLrgKwzEofodiG3b/DPbHbegRh91Ygqz2MAfMl6ArDvMZ1KtdXoZ5D+34dw91g3aca1CrPgPMNN5RMxhbbjDa8i628bcOY3PPqzl9Dwvb9MbyQtruAesk7fMDjeM9TCy9NvqafankXPNj/ZaoK9S0nBD9AoncQPCGBJ+JvkJSKCBtSLWZ+FkItDlNQQl85p3MQTZSE+1EX7SOTwVwwZf5EbgJxcMDQUcPQ/tNmK8G4HKoh/21C10BbJkAd9DbPXSJzwZtRAWIfcRWc62W5HBTS+kpjSAS1xOAGSzI+ReCCH7YpXeR/KyEVDSBQJ8eWWAPYFVfOEeR29YnCAFyeXSAmh6cZNDD09MHe00JA9CZN3KdRtQ+grhX4zskvL5//s5A5Hj/tPXLoKAtGP6E4l4obkHv62GzkYIOA3aTCtpKJaErYqgah4WCOijVhQKwKaizQRWcW94nS4IuVDMCkQT5LqyzBJz2RCtWp/QDhABcqy2F0cmCwBprXt0UFGqq9/lM4PdUVZkPqtKqxL1fQaXesF8Jv9aKd0cqoOOE0xXx2Q75qBsXCeUQ+Y2OTgRbqaDvYRHejkEf2obtVIijgjZ3oKtb6HwlgNOVQ0OIWx4riEoiMQSdpN1BQVBoKI/gVKijguix83BXYAfQLbkO4SlVUGNzRdDT9yiIFWqFqEzGRa7yw3XkxeX1DDMBTKolk3WSOYSqUtNoLO3+DwXdqYpjKI4c1BSUbThJ5aZbU5GwoCLhzGX/Fj0emzsZc2LlllYktHPQP4qEystIoq5PBC2KoIv+HoBX61wT+WdPiI1QFyovFUZBMqroqkhY0A7vcrOnN/xZAT4LEoa81yq3diZinsnnNicLCOZKVqwnJwUt0JHevOQX4HhmfBaal+tDmZ1HjjoeRGUqUXFe+3BNXpoIWiBBp7/xR63DVyI4Oq/ixuegoTSPg+roDLUp01XPApkZmT674U+74hM4jozUw9AmdaPdSvt2q31Dgdemy9KD4SdW4aVpD7yvkuGuSui8wRju5Zirpn83HCAv+5Zav+LPywyvKPAcgEfq/u23//qH3d+BYW6gbfXPHQAAAABJRU5ErkJggg=="
          />

          {{ tenantConfig.brandName }}的教学流程智能化
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABKFJREFUWEftWc+LXEUQ/urNjM6KG3IxN2/rxb8gag5CILhZLyIigoI5eNNs4sGLFw/+CTmJG+IGPHgQcsmsEUXwBypeFPwRFNGLlwRxdUIyM6+qpKqre3qye8w7zSwsr1+/7nrd9dX3VfUbwiF/r470SQGeUeC4EI6p4LYC1wFcV8L7727SD4fNW/Xdew9QbfL8nm7MFBcEeEwVIoAowAoI4PfWZiV83NyHt3dO0p/3fkkri7UHCkBnR3pCgQ8EWFeFBhAGDIs6KGKg5X4R3MAAL146Rb+uXNqdBxygs9f0ERV8AcW6scWZYmAQxMBx9lBiDww8BQs5q272FM/vbK2Y1BVEDtD2SD9RxQlzujvfJC3AcVCS1BW5UwJzAKfAtd3T9FpXC1x2u/T6SE+2wEcGDBJLnEEFIIVWuccZ5OAYmJGT+g1euPgUfb/szuxi/3T+qr4jhDMOzGG5xvoSoywXebGQJc4Bsr4mPasKCr93RiZZFGnAKm7LAbfcZky0fBd5zmXU+1OQ+FwbS4nNyRZB2OwkiV3IjVmabTzbPE1XW0du2zNbR16bXc12k8axCMTfl3KvX92eRLsJ2xJXuycwMaS1sQyhBtJaXwOZTsHUc5s8AfgBgd6xZwDfmkDW+5AegZv7IX/fBONhMG5A8CMEb4Fpe09/hmIjqra7N5ycEjnIHZ0dXjEo5C/lq9Sf2gFcmWcbnQOeAmJeJbq0RsXoznLwEzAlBxYQAmgHIoCSAC4cmvNkAbUGrgLIAsdBmUkCw9sBcAkQTs+mFkQx3t6dwXFQ7gaohUwBHvbSPANqcgdMfYj/E3g8BmMAwS2zCsYQgkfB+AmM5yC0PdL/VLHmDJnnmRT18zxUyuwqasv4kMPCoGCIz7FoN6AWIj8DXRchBoSxTD2/5Si2gGhtbmaAAxYMCfAOsigFlTPTGRT2MqvsPQamWMFjjotgy4ypWettY0uwytrUB5vDB5zY0zYQZ06wKLNngUFDMI0hkzUwzSAWVDSAjBvw0dsQZ1APjP2kDHgIgs8gdG6k/yqwVktILVfZ2XUVZyygStbKGSmcFxLVmpwViZufoRKQxo4AyIuSJGeJQUkS28zqLHGV3CSJq8r+EggZmJAx32wli2arDaa4hJqNHlhmEOknMJxBxphmLnHCzhaXLw42FQY1SSJnBpLJWRsSFww6IHFDtDSBOEBj8NEB5B8LYgNnCNl4EPLbGK0z6NxIfxFgA1E658Qfm3IaWkRbpEX+WcxByQG/727S010kyWW36UUCE844CyKHZJ2PyLaobuNMVBJ1jr6QnA93T9Oby+7MLvbvZTYDe071YInngJCwOKgWnc8luOWKKAYMtJcvb9E3XSxw2W3mg+qnqngiH1RzZWWAOYtSwVC+JNTnIBC+fW+TXlp2R3a1//pTz+cqOOKJuyqlvRJKCX1+Dpq390F49tIm/dHVApfd7oGPpQocqb7FFVBKNRdVkRL2ifHKxS36btmd2OX+D/zcMFVcUMXjXvYussnPRn4oJXxNgjdWH0m7hCbZXgAovy7/YCfAcQWO+XlG8ZcSvtIeruycoi+7X9rqDeaB/wEbDb3MbAVAFAAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="second-body" style="position: relative">
          <img src="../assets/index2/intelligence-content.png" alt="" />
          <p
            style="
              top: 0;
              position: absolute;
              line-height: 390px;
              text-align: center;
              width: 100%;
              color: rgb(139, 140, 156);
              font-size: 18px;
            "
          >
            智能技术在十步闭环学习法中达到全方面应用，实现更精准的教学与评价，保障学习效果
          </p>
        </div>
      </div>
      <!-- 文章 -->
      <div class="index-container sub gray">
        <div class="second-title">
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABFxJREFUWEftWUFrXlUQPTPzkrSGVhGroIsiIu50I4roSrFtVuJCF0KrNC79CW5duVBbl4JCF6IIgpK2FMQuLPofrD9ABRepNW2S742cmbnfeyZV3HzZ9AXCfbn3vrn3nTNnZu6NYPo5MATevuRPiuMNAE/w1wT3CPCrAD8p8PXHa3J172bkwHZ3Fy+0/p0f77fxrjpehkAVMDhMkM9sJft/XBK888Epud7gmghasOO8dcUflx1cEMWD4jCMSIlnEsN+gXJcBZsCvH5uTX7g1iaCFkjQ+oYfnwm+APCAOnSunkYGlQSoAQoqif3Zt6mGF86dkJ8nghZI0JmLfl6AEwSdShEvAlI1SQrHhhDH0JdhT3Hto1Py4kTQggg6e9mf2u3xeSOHwBcZEc4Y1kgaFSRAJ4BEbiI5nCvxfFLgLrgKwzEofodiG3b/DPbHbegRh91Ygqz2MAfMl6ArDvMZ1KtdXoZ5D+34dw91g3aca1CrPgPMNN5RMxhbbjDa8i628bcOY3PPqzl9Dwvb9MbyQtruAesk7fMDjeM9TCy9NvqafankXPNj/ZaoK9S0nBD9AoncQPCGBJ+JvkJSKCBtSLWZ+FkItDlNQQl85p3MQTZSE+1EX7SOTwVwwZf5EbgJxcMDQUcPQ/tNmK8G4HKoh/21C10BbJkAd9DbPXSJzwZtRAWIfcRWc62W5HBTS+kpjSAS1xOAGSzI+ReCCH7YpXeR/KyEVDSBQJ8eWWAPYFVfOEeR29YnCAFyeXSAmh6cZNDD09MHe00JA9CZN3KdRtQ+grhX4zskvL5//s5A5Hj/tPXLoKAtGP6E4l4obkHv62GzkYIOA3aTCtpKJaErYqgah4WCOijVhQKwKaizQRWcW94nS4IuVDMCkQT5LqyzBJz2RCtWp/QDhABcqy2F0cmCwBprXt0UFGqq9/lM4PdUVZkPqtKqxL1fQaXesF8Jv9aKd0cqoOOE0xXx2Q75qBsXCeUQ+Y2OTgRbqaDvYRHejkEf2obtVIijgjZ3oKtb6HwlgNOVQ0OIWx4riEoiMQSdpN1BQVBoKI/gVKijguix83BXYAfQLbkO4SlVUGNzRdDT9yiIFWqFqEzGRa7yw3XkxeX1DDMBTKolk3WSOYSqUtNoLO3+DwXdqYpjKI4c1BSUbThJ5aZbU5GwoCLhzGX/Fj0emzsZc2LlllYktHPQP4qEystIoq5PBC2KoIv+HoBX61wT+WdPiI1QFyovFUZBMqroqkhY0A7vcrOnN/xZAT4LEoa81yq3diZinsnnNicLCOZKVqwnJwUt0JHevOQX4HhmfBaal+tDmZ1HjjoeRGUqUXFe+3BNXpoIWiBBp7/xR63DVyI4Oq/ixuegoTSPg+roDLUp01XPApkZmT674U+74hM4jozUw9AmdaPdSvt2q31Dgdemy9KD4SdW4aVpD7yvkuGuSui8wRju5Zirpn83HCAv+5Zav+LPywyvKPAcgEfq/u23//qH3d+BYW6gbfXPHQAAAABJRU5ErkJggg=="
          />

          {{ tenantConfig.brandName }}的口碑好
          <img
            style="width: 52px; height: 10px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAASCAYAAAC3pZsGAAAAAXNSR0IArs4c6QAABKFJREFUWEftWc+LXEUQ/urNjM6KG3IxN2/rxb8gag5CILhZLyIigoI5eNNs4sGLFw/+CTmJG+IGPHgQcsmsEUXwBypeFPwRFNGLlwRxdUIyM6+qpKqre3qye8w7zSwsr1+/7nrd9dX3VfUbwiF/r470SQGeUeC4EI6p4LYC1wFcV8L7727SD4fNW/Xdew9QbfL8nm7MFBcEeEwVIoAowAoI4PfWZiV83NyHt3dO0p/3fkkri7UHCkBnR3pCgQ8EWFeFBhAGDIs6KGKg5X4R3MAAL146Rb+uXNqdBxygs9f0ERV8AcW6scWZYmAQxMBx9lBiDww8BQs5q272FM/vbK2Y1BVEDtD2SD9RxQlzujvfJC3AcVCS1BW5UwJzAKfAtd3T9FpXC1x2u/T6SE+2wEcGDBJLnEEFIIVWuccZ5OAYmJGT+g1euPgUfb/szuxi/3T+qr4jhDMOzGG5xvoSoywXebGQJc4Bsr4mPasKCr93RiZZFGnAKm7LAbfcZky0fBd5zmXU+1OQ+FwbS4nNyRZB2OwkiV3IjVmabTzbPE1XW0du2zNbR16bXc12k8axCMTfl3KvX92eRLsJ2xJXuycwMaS1sQyhBtJaXwOZTsHUc5s8AfgBgd6xZwDfmkDW+5AegZv7IX/fBONhMG5A8CMEb4Fpe09/hmIjqra7N5ycEjnIHZ0dXjEo5C/lq9Sf2gFcmWcbnQOeAmJeJbq0RsXoznLwEzAlBxYQAmgHIoCSAC4cmvNkAbUGrgLIAsdBmUkCw9sBcAkQTs+mFkQx3t6dwXFQ7gaohUwBHvbSPANqcgdMfYj/E3g8BmMAwS2zCsYQgkfB+AmM5yC0PdL/VLHmDJnnmRT18zxUyuwqasv4kMPCoGCIz7FoN6AWIj8DXRchBoSxTD2/5Si2gGhtbmaAAxYMCfAOsigFlTPTGRT2MqvsPQamWMFjjotgy4ypWettY0uwytrUB5vDB5zY0zYQZ06wKLNngUFDMI0hkzUwzSAWVDSAjBvw0dsQZ1APjP2kDHgIgs8gdG6k/yqwVktILVfZ2XUVZyygStbKGSmcFxLVmpwViZufoRKQxo4AyIuSJGeJQUkS28zqLHGV3CSJq8r+EggZmJAx32wli2arDaa4hJqNHlhmEOknMJxBxphmLnHCzhaXLw42FQY1SSJnBpLJWRsSFww6IHFDtDSBOEBj8NEB5B8LYgNnCNl4EPLbGK0z6NxIfxFgA1E658Qfm3IaWkRbpEX+WcxByQG/727S010kyWW36UUCE844CyKHZJ2PyLaobuNMVBJ1jr6QnA93T9Oby+7MLvbvZTYDe071YInngJCwOKgWnc8luOWKKAYMtJcvb9E3XSxw2W3mg+qnqngiH1RzZWWAOYtSwVC+JNTnIBC+fW+TXlp2R3a1//pTz+cqOOKJuyqlvRJKCX1+Dpq390F49tIm/dHVApfd7oGPpQocqb7FFVBKNRdVkRL2ifHKxS36btmd2OX+D/zcMFVcUMXjXvYussnPRn4oJXxNgjdWH0m7hCbZXgAovy7/YCfAcQWO+XlG8ZcSvtIeruycoi+7X9rqDeaB/wEbDb3MbAVAFAAAAABJRU5ErkJggg=="
          />
        </div>
        <div class="second-desc">借贴心的服务，看得见的效果赢得各界认可</div>
        <div class="second-body">
          <a-card :bordered="false" style="border-radius: 24px">
            <a-list
              :grid="{
                gutter: 24,
              }"
              item-layout="vertical"
              size="large"
              :dataSource="cmsDataSource"
              class="cms-list"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <a-card :bordered="false" @click="toCmsDetail(item)">
                  <a-row :gutter="24">
                    <a-col :span="item.cmsCover ? 6 : 0">
                      <div class="img-zoom">
                        <img class="cover" :src="item.cmsCover_url" alt="" />
                      </div>
                    </a-col>
                    <a-col :span="item.cmsCover ? 18 : 24">
                      <h3 class="title">{{ item.cmsTitile }}</h3>
                    </a-col>
                  </a-row>
                </a-card>
              </a-list-item>
            </a-list>
          </a-card>
        </div>
      </div>
      <!-- 荣誉资质 -->
      <div class="index-container skyblue">
        <div class="second-title">荣誉资质</div>
        <div class="second-body certs">
          <img v-for="u in certImgs" :src="u" :key="u" alt="" />

        </div>
      </div>
      <!-- 合作单位 -->
      <div class="index-container skyblue">
        <div class="second-title">合作单位</div>
        <div class="second-body logos">
          <img v-for="u in comImgs" :src="u" :key="u" alt="" />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import { getAction } from "@/api/manage";
import Footer from "@/components/footer/Footer";
import {
  getEditorUrl,
  getPlayerUrl,
  getCodeIcon,
} from "@/utils/codeTypeUtil.js";

export default {
  components: { Footer},
  data() {
    return {
      bannerList: [],
      bannerLinksList: [],
      isTypewriter: false,
      teacherBannerList: [],
      workList: [],
      certImgs: [],
      comImgs: []
    };
  },
  watch: {},
  methods: {},
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    if (this.tenantConfig && this.tenantConfig.banner) {
      this.bannerList = this.tenantConfig.banner.split(",");
    }
    if(this.tenantConfig.bannerLinks){
      this.bannerLinksList = this.tenantConfig.bannerLinks.split("\n");
    }
    if (this.tenantConfig && this.tenantConfig.banner2) {
      this.teacherBannerList = this.tenantConfig.banner2.split(",");
      let bannerList = this.tenantConfig.banner2.split(",");
      let bannerNameList = [];
      if(this.tenantConfig.bannerLinks2){
        bannerNameList = this.tenantConfig.bannerLinks2.split("\n");
      }
      
      for (let i = 0; i < bannerList.length; i++) {
        this.teacherBannerList[i] = {
          img: bannerList[i],
          name: bannerNameList.length <= (i-1) ? bannerNameList[i] : '',
        };
      }
    }
    if (this.tenantConfig.cert) {
      this.certImgs = this.tenantConfig.cert.split(",");
    }
    if (this.tenantConfig.com) {
      this.comImgs = this.tenantConfig.com.split(",");
    }
    this.getWorkList();
    this.getCmsList();
    // let timer = setTimeout(()=>{this.AIxStatus = true ,clearTimeout(timer)},5000)
  },
  mounted() {
    let that = this;
  },
  methods: {
    getEditorUrl,
    getPlayerUrl,
    getCodeIcon,
    getWorkList() {
      this.workList = [];
      let queryParam = {
        pageNo: 1,
        pageSize: 4,
        langType: undefined,
        tag: "",
        orderBy: "star",
      };
      getAction("/teaching/teachingWork/leaderboard", queryParam).then(
        (res) => {
          if (res.success) {
            this.workList = res.result.records;
          }
        }
      );
    },
    toDetail(info) {
      if (info.codeType == 0) {
        this.$router.push("/work/mdView?workId=" + info.id);
      } else {
        this.$router.push("/work/detail?workId=" + info.id);
      }
    },
    getCmsList() {
      let queryParam = {
        pageNo: 1,
        pageSize: 5,
      };
      getAction("/teaching/teachingCms/getCmsList", queryParam).then((res) => {
        if (res.success) {
          this.info = res.result;
          this.cmsDataSource = res.result.records;
          this.pagination.total = res.result.total;
        }
        this.loading = false;
      });
    },
    toCmsDetail(item) {
      console.log(item);
      if (item.cmsType == 5) {
        // 外链
        window.open(item.extraLink);
      } else if (item.cmsType == 2) {
        this.currentItem = item;
        this.videoVisible = true;
        getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id).then(
          (res) => {}
        );
      } else {
        let route = this.$router.resolve({
          path: "/cms/detail",
          query: {
            id: item.id,
          },
        });
        window.open(route.href, "_blank");
      }
    },
  },
};
</script>
<style lang='less' scoped>
.slick-arrow {
  border-radius: 50%;
  text-align: center;
  height: 40px;
  line-height: 40px;
  width: 40px;
  background: #364e799a;
  overflow: hidden;
  color: #fff;
  opacity: 0.5;
  img {
    width: 100%;
    height: 100%;
  }
}
.slick-arrow:hover {
  background: #364e79;
  color: #fff;
  opacity: 1;
}
#IndexPage {
  width: 100%;
  height: auto;
  .banner {
    width: 100%;
    height: 100%;
    background: #ccc;
    .video-box {
      position: relative;
    }
    .video-mask {
      position: absolute;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, #5c9bff, #4748ff);
      opacity: 0.7;
    }
    .video {
      width: 100%;
    }
    .typed {
      position: absolute;
      top: 50%;
      width: 100%;
      /deep/.typed-element {
        justify-content: center;
        .typing {
          color: #fff;
          font-size: 2rem;
        }
        .typed-cursor {
          color: #fff;
          font-size: 2rem;
        }
      }
    }
    .img {
      width: 100%;
    }
  }
  .index-content {
    .index-container {
      padding-bottom: 80px;
    }
    .gray {
      background: rgb(245, 249, 255);
    }
    .skyblue {
      background: rgb(246, 250, 254);
    }
    .second-title {
      text-align: center;
      font-size: 40px;
      color: #2c3040;
      line-height: 56px;
      margin: 0 auto 20px;
      padding-top: 80px;
    }
    .second-desc {
      text-align: center;
      font-size: 16px;
      color: #8b8c9c;
      line-height: 22px;
      margin: 20px;
    }
    .second-body {
      max-width: 1200px;
      margin: auto;
      img {
        max-width: 100%;
      }
    }
    .sub {
      .second-title {
        text-align: center;
        font-size: 32px;
        color: #2c3040;
        line-height: 48px;
        margin: 0 auto 20px;
        padding-top: 80px;
      }
    }
    .ai-list {
      /deep/.ant-card {
        border-radius: 24px;
        overflow: hidden;
        box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
        .ant-card-body {
          padding: 0 0 24px 0;
        }
        img {
          width: 100%;
        }
        .title {
          margin: 20px auto 12px 24px;
          color: #2c3040;
          font-size: 24px;
          line-height: 33px;
        }
        .text {
          padding: 0 24px;
          font-size: 16px;
          color: #8b8c9c;
          line-height: 22px;
        }
      }
    }

    .editor-list {
      /deep/.ant-card {
        height: 288px;
        width: 264px;
        background-size: 100% 100%;
        .ant-card-body {
          padding: 0 0 24px 0;
        }
        .title {
          margin: 20px auto 12px 24px;
          color: #fff;
          font-size: 28px;
        }
        .text {
          padding: 0 24px;
          font-size: 16px;
          color: #fff;
          line-height: 22px;
        }
        .age {
          margin: 120px auto 12px 24px;
          color: #fff;
          font-size: 18px;
        }
      }
    }

    .course-list {
      /deep/.ant-card {
        width: 343px;
        border-radius: 24px;
        background-size: 100% 100%;
        box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.1);
        .ant-card-body {
        }
        .title {
          margin: 20px auto 12px 24px;
          color: #000;
          font-size: 28px;
        }
        .text {
          padding: 0 24px;
          font-size: 16px;
          color: #8b8c9c;
          line-height: 22px;
        }
      }
    }

    .work-card {
      border: none;
      /deep/.ant-card-body {
        width: 250px;
        height: 280px;
        padding: 0;
        overflow: hidden;
        border-radius: 10px;
        box-shadow: 0px 3px 6px #00000039;
      }
      .ant-divider-horizontal {
        margin: 12px 0;
      }
      .work-cover {
        width: 100%;
        max-height: 150px;
        overflow: hidden;
        img {
          display: block;
          max-width: 100%;
          max-height: 100%;
          margin: auto;
        }
      }
      .work-author {
        padding: 10px 10px 0;
        span {
          line-height: 40px;
        }
      }
      .work-op {
        a {
          color: black;
        }
        a:hover {
          color: #1890ff;
        }
        padding: 0 10px;
      }
    }
    .cms-list {
      .cover {
        max-width: 250px;
      }
    }
  }
}

.logos {
  img {
    margin: 5px 8px;
    max-height: 100px;
    // background: #1890ff;
  }
}
.certs{
  img {
    margin: 5px 8px;
    max-height: 250px;
    // background: #1890ff;
  }
}
</style>